module.exports = __webpack_public_path__ + "img/jouer-mobile.df8c1b0d.png";